import { Outlet } from 'react-router-dom'

import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ProjectsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/project_management/lib/CollectionsBootstrap'

import { LoadingState } from '../components/LoadingState'
import { OnboardingContextProvider } from '../contexts/onboardingContext'

const Container = () => {
  const { company } = useCurrentSession()
  const { loading: loadingPage, data: page } = useQuery(ProjectsRootPageDocument, {
    variables: {
      companyId: company.id,
      featureIds: [
        Features.projects_management,
        Features.projects_costs,
        Features.projects_clients,
        Features.projects_budget,
        Features.projects_overview,
      ],
      moduleId: AvailableModules.expenses,
    },
  })

  if (loadingPage) return <LoadingState />

  const canAccess = page?.projectManagement._policies.accessManageProjects.can ?? false
  const hasExpenses = page?.companies.moduleAvailability?.available
  const hasProjectsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_management
  )?.available
  const hasCostsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_costs
  )?.available

  const hasClientsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_clients
  )?.available

  const hasBudgetFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_budget
  )?.available

  const hasPayingProjectsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_overview
  )?.available

  const isAuthorized = canAccess && hasProjectsFeature

  return (
    <AuthorizeUser authorizeFn={() => company && isAuthorized}>
      <OnboardingContextProvider>
        <Outlet
          context={{
            hasBudgetFeature,
            hasCostsFeature,
            hasExpenses,
            hasClientsFeature,
            hasPayingProjectsFeature,
          }}
        />
      </OnboardingContextProvider>
    </AuthorizeUser>
  )
}

const ProjectsRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default ProjectsRootPage
